import React from 'react';
import {useFormContext, Controller} from 'react-hook-form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './datepicker.scss';
import {getLanguage} from 'react-switch-lang';
import en from 'date-fns/locale/en-US';
import me from 'date-fns/locale/sr-Latn';

const InputYear = ({
                     name,
                     defaultValue,
                     className = 'form-control height-big',
                     minDate,
                     ...rest
                   }) => {
  const {control, errors, watch} = useFormContext();
  const selected = watch(name);

  const lang = getLanguage();

  return (
    <>
      <Controller
        defaultValue={defaultValue ? new Date(defaultValue, 1, 1) : null}
        className={`${className} ${errors[name] && 'error-field'}`}
        as={DatePicker}
        name={name}
        control={control}
        minDate={minDate}
        selected={selected}
        autoComplete={'off'}
        placeholderText={'_ _ _ _'}
        showYearPicker
        dateFormat="yyyy"
        locale={lang === 'eng'? en : me}
        {...rest}
      />
      {errors[name] && (
        <span className="error-message">{errors[name].message}</span>
      )}
    </>
  );
};

export default InputYear;
